<template>
<div class="chapter">
<div class="inner_page">
<p class="fm1"><span>For my parents, Sondra and Daniel and in memory of my teacher and friend Ed Levy</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?464ab025